import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError, retry } from 'rxjs/operators';
import { URLsConfig } from '../URLsConfig';
import { UserPermModel } from '../models/UserPermModel';


@Injectable()
export class UserPermService {
    constructor(private http: HttpClient, public urlsconfig: URLsConfig) {
    }
    public getUserPermission(usGroup: string , compCode: string) {

      let params = new HttpParams();
        params = params.append("usGroup", usGroup);
        params = params.append("compCode", compCode);
        const options = {
          params: params
      };
      return this.http.get<UserPermModel>(this.urlsconfig.WebAPIURL_Test + 'api/UserGroup/GetUserGroup',options);
    }


    public AddUserPermission(userGroup: UserPermModel) {
        return this.http.post<UserPermModel>(this.urlsconfig.WebAPIURL_Test + 'api/UserGroup/AddUserGroup', userGroup);
    }
  }
